<template>
  <div
    v-if="actualVector.showEditColors"
    class="justify-content-center align-items-center vx-btns-svg"
  >
    <a
      href="https://www.vexels.com/t-shirt-maker"
      target="_blank"
      class="vx-btn-container"
      @click="clickShirtMaker()"
    >
      <div class="icon-shirt">
        <img
          src="https://cdn.vexels.com/img/icons/merch_only_white.svg"
          height="31"
          width="36"
          :alt="$t('preview.main.content.merchOnlyIconWhiteAlt')"
          loading="lazy"
        />
      </div>

      <div>
        <p class="tooltip-description">
          {{ $t('main.preview.editColor.tooltipMerch') }}
        </p>
      </div>
    </a>

    <div class="vx-btn-container" @click="openEditColor">
      <button type="button" class="icon-edit btn p-0 border-l">
        <img
          src="https://cdn.vexels.com/img/edit-colors.svg"
          width="36"
          height="36"
          :alt="$t('main.preview.editColor.colorsWheelAlt')"
          loading="lazy"
        />
      </button>

      <div>
        <p class="tooltip-description">
          {{ $t('main.preview.editColor.tooltipEdit') }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
  computed: {
    ...mapState('vectors', ['actualVector', 'showEditColor'])
  },
  methods: {
    openEditColor() {
      if (!this.showEditColor) {
        this.$store.dispatch('vectors/LOAD_SVG_CONTENT', this.actualVector.id).then(() => {
          this.$store.dispatch('vectors/EDIT_COLOR_DATA');
        });
      }
      this.$store.dispatch('vectors/SET_SHOW_EDIT_COLOR', !this.showEditColor);
    },
    clickShirtMaker() {
      const data = { artId: this.actualVector.id };
      localStorage.setItem('vx-try-editor', JSON.stringify(data));
    }
  }
};
</script>
<style scoped lang="scss">
.vx-btns-svg {
  margin-top: 10px;
  margin-bottom: 30px;
  display: flex;
  z-index: 20;
  .vx-btn-container {
    padding: 4px 9px;
    border-radius: 7px;
    cursor: pointer;
    align-items: center;
    display: flex;
    background: #fff;
    margin: 0 10px 0 0;
    .icon-shirt {
      background-color: #3f80f1;
      width: 28px;
      height: 28px;
      border-radius: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .icon-edit img {
      width: 28px;
      height: 28px;
    }
    .tooltip-description {
      color: #414141;
      font-size: 13px;
      margin: 0 0 0 10px;
    }
    &:hover {
      background: rgb(249, 249, 249);
    }
  }
  .merch-tshirt {
    padding: 0 5px;
    margin: 0 5px;
    @include lg {
      border-bottom: none;
      border-right: 1px solid #e2e2e2;
      padding: 0 15px 0 0;
      margin: 0 15px 0 0;
    }
    @include sm {
      padding: 0 10px 0 0;
      margin: 0 10px 0 0;
    }
  }
}
</style>
